import { h } from 'vue'
import type { IconSet, IconProps, IconAliases } from 'vuetify'

import circleSvg from '@/assets/icons/circle.svg'
import checkedBox from '@/assets/icons/checked-box.svg'
import checkboxDeterminerSvg from '@/assets/icons/checkbox-determiner.svg'
import checkSvg from '@/assets/icons/check.svg'
import checkCircleFillSvg from '@/assets/icons/check-circle-fill.svg'
import addSvg from '@/assets/icons/add.svg'
import chevronDown from '@/assets/icons/chevron-down.svg'
import chevronUp from '@/assets/icons/chevron-up.svg'
import chevronLeft from '@/assets/icons/chevron-left.svg'
import chevronRight from '@/assets/icons/chevron-right.svg'
import chevronLeftDouble from '@/assets/icons/chevron-left-double.svg'
import chevronRightDouble from '@/assets/icons/chevron-right-double.svg'
import arrowLeftRoundSvg from '@/assets/icons/arrow-left-round.svg'
import arrowRightRoundSvg from '@/assets/icons/arrow-right-round.svg'
import arrowUpRoundSvg from '@/assets/icons/arrow-up-round.svg'
import arrowDownSvg from '@/assets/icons/arrow-down.svg'
import arrowLeftSvg from '@/assets/icons/arrow-left.svg'
import arrowRightSvg from '@/assets/icons/arrow-right.svg'
import locationSvg from '@/assets/icons/location.svg'
import arrowUpSvg from '@/assets/icons/arrow-up.svg'
import calendarSvg from '@/assets/icons/calendar.svg'
import cancelSvg from '@/assets/icons/cancel.svg'
import cancelCircleSvg from '@/assets/icons/cancel-circle.svg'
import customerSupportSvg from '@/assets/icons/customer-support.svg'
import deleteSvg from '@/assets/icons/delete.svg'
import downloadSvg from '@/assets/icons/download.svg'
import errorSvg from '@/assets/icons/error.svg'
import warningCircleFillSvg from '@/assets/icons/warning-circle-fill.svg'
import filterSvg from '@/assets/icons/filter.svg'
import emptySvg from '@/assets/icons/empty.svg'
import filterHorizontalSvg from '@/assets/icons/filter-horizontal.svg'
import filterVerticalSvg from '@/assets/icons/filter-vertical.svg'
import linkLinearSvg from '@/assets/icons/link-linear.svg'
import chatSlashSvg from '@/assets/icons/chat-slash.svg'
import linkSvg from '@/assets/icons/link.svg'
import listSvg from '@/assets/icons/list.svg'
import gavelSvg from '@/assets/icons/gavel.svg'
import loginSvg from '@/assets/icons/login.svg'
import logoutSvg from '@/assets/icons/logout.svg'
import logoutCircleSvg from '@/assets/icons/logout-circle.svg'
import deleteCircleSvg from '@/assets/icons/delete-circle.svg'
import refreshSvg from '@/assets/icons/refresh.svg'
import reloadSvg from '@/assets/icons/reload.svg'
import removeSvg from '@/assets/icons/remove.svg'
import searchSvg from '@/assets/icons/search.svg'
import sidebarCloseSvg from '@/assets/icons/sidebar-close.svg'
import sidebarOpenSvg from '@/assets/icons/sidebar-open.svg'
import viewSvg from '@/assets/icons/view.svg'
import viewOffSvg from '@/assets/icons/view-off.svg'
import userSvg from '@/assets/icons/user.svg'
import lockSvg from '@/assets/icons/lock.svg'
import radioDefaultSvg from '@/assets/icons/radio-default.svg'
import radioActiveSvg from '@/assets/icons/radio-active.svg'
import starEmptySvg from '@/assets/icons/star-empty.svg'
import starHalfSvg from '@/assets/icons/star-half.svg'
import starFillSvg from '@/assets/icons/star-fill.svg'
import notificationSvg from '@/assets/icons/notification.svg'
import chartPieSvg from '@/assets/icons/chart-pie.svg'
import buildingOfficeSvg from '@/assets/icons/building-office.svg'
import scalesSvg from '@/assets/icons/scales.svg'
import pencilSvg from '@/assets/icons/pencil.svg'
import usersSvg from '@/assets/icons/users.svg'
import sendSvg from '@/assets/icons/paper-plant-tilt.svg'
import userCircleSvg from '@/assets/icons/user-circle.svg'
import terminationSvg from '@/assets/icons/termination.svg'
import signatureSvg from '@/assets/icons/signature.svg'
import uploadFileSvg from '@/assets/icons/upload-file.svg'
import fileDocumentSvg from '@/assets/icons/file-document.svg'
import dotsThreeSvg from '@/assets/icons/dots-three.svg'
import dotSvg from '@/assets/icons/dot.svg'
import coinsSvg from '@/assets/icons/coins.svg'
import notePencilSvg from '@/assets/icons/note-pencil.svg'
import houseLineSvg from '@/assets/icons/house-line.svg'
import handShakeSvg from '@/assets/icons/hand-shake.svg'
import discountSvg from '@/assets/icons/discount.svg'
import boxSvg from '@/assets/icons/box.svg'
import boxInfoSvg from '@/assets/icons/box-info.svg'
import giftSvg from '@/assets/icons/gift.svg'
import promotionSvg from '@/assets/icons/promotion.svg'
import userSettingSvg from '@/assets/icons/user-setting.svg'

const aliases: IconAliases = {
  collapse: chevronUp,
  complete: checkSvg,
  discount: discountSvg,
  box: boxSvg,
  boxInfo: boxInfoSvg,
  coins: coinsSvg,
  cancel: cancelSvg,
  close: cancelSvg,
  delete: deleteSvg,
  location: locationSvg,
  clear: cancelSvg,
  success: checkSvg,
  handShake: handShakeSvg,
  checkCircleFill: checkCircleFillSvg,
  info: notificationSvg,
  warning: errorSvg,
  warningCircleFill: warningCircleFillSvg,
  error: cancelCircleSvg,
  prev: chevronLeft,
  chatSlash: chatSlashSvg,
  send: sendSvg,
  gavel: gavelSvg,
  dotsThree: dotsThreeSvg,
  next: chevronRight,
  checkboxOn: checkedBox,
  checkboxOff: checkboxDeterminerSvg,
  checkboxIndeterminate: removeSvg,
  termination: terminationSvg,
  delimiter: circleSvg,
  sortAsc: arrowUpSvg,
  sortDesc: arrowDownSvg,
  expand: chevronDown,
  menu: listSvg,
  subgroup: arrowDownSvg,
  dropdown: chevronDown,
  radioOn: radioActiveSvg,
  radioOff: radioDefaultSvg,
  edit: filterHorizontalSvg,
  empty: emptySvg,
  ratingEmpty: starEmptySvg,
  ratingHalf: starHalfSvg,
  ratingFull: starFillSvg,
  loading: arrowDownSvg,
  first: chevronLeftDouble,
  last: chevronRightDouble,
  unfold: arrowDownSvg,
  file: linkSvg,
  plus: addSvg,
  minus: removeSvg,
  pencil: pencilSvg,
  arrowLeftRound: arrowLeftRoundSvg,
  arrowRightRound: arrowRightRoundSvg,
  arrowUpRound: arrowUpRoundSvg,
  arrowLeft: arrowLeftSvg,
  arrowRight: arrowRightSvg,
  calendar: calendarSvg,
  customerSupport: customerSupportSvg,
  download: downloadSvg,
  filter: filterSvg,
  filterVertical: filterVerticalSvg,
  linkLinear: linkLinearSvg,
  link: linkSvg,
  list: listSvg,
  login: loginSvg,
  logout: logoutSvg,
  logoutCircle: logoutCircleSvg,
  deleteCircle: deleteCircleSvg,
  refresh: refreshSvg,
  reload: reloadSvg,
  search: searchSvg,
  sidebarClose: sidebarCloseSvg,
  sidebarOpen: sidebarOpenSvg,
  view: viewSvg,
  viewOff: viewOffSvg,
  user: userSvg,
  userCircle: userCircleSvg,
  signature: signatureSvg,
  lock: lockSvg,
  chartPie: chartPieSvg,
  buildingOffice: buildingOfficeSvg,
  scales: scalesSvg,
  users: usersSvg,
  uploadFile: uploadFileSvg,
  fileDocument: fileDocumentSvg,
  dot: dotSvg,
  notePencil: notePencilSvg,
  houseLine: houseLineSvg,
  gift: giftSvg,
  promotion: promotionSvg,
  userSetting: userSettingSvg,
}

const custom: IconSet = {
  component: ({ icon, ...restProps }: IconProps) => {
    const IconComponent = aliases[icon as keyof typeof aliases]

    return IconComponent ? h(IconComponent, restProps) : null
  },
}

export { aliases, custom }
